/**
 * "Restart training" from the account menu: a confirmation, then the progress is reset
 * (the first completion stays on record) and the training opens.
 */

import { AlertDialog, Button } from "@norican/react";
import { useNavigate } from "react-router";

import { useResetTraining } from "@/lib/api";
import { logger } from "@/lib/logger";

export const RESTART_TEXT = "Start the training again? Your completion stays on record.";

export function RestartTrainingDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) {
  const reset = useResetTraining();
  const navigate = useNavigate();
  return (
    <AlertDialog.Root open={open} onOpenChange={onOpenChange}>
      <AlertDialog.Portal>
        <AlertDialog.Backdrop />
        <AlertDialog.Popup>
          <AlertDialog.Title>Restart training</AlertDialog.Title>
          <AlertDialog.Description>{RESTART_TEXT}</AlertDialog.Description>
          <div className="mt-4 flex flex-wrap justify-end gap-2">
            <AlertDialog.Close render={<Button variant="outline" tone="neutral" />}>
              Cancel
            </AlertDialog.Close>
            <Button
              tone="accent"
              loading={reset.isPending}
              onClick={() => {
                logger.debug("[training] restart");
                reset.mutate(undefined, {
                  onSettled: () => {
                    onOpenChange(false);
                    navigate("/training");
                  },
                });
              }}
            >
              Restart
            </Button>
          </div>
        </AlertDialog.Popup>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
